type ConfirmationJob = {
  name:string; status:string; statistics:Record<string,number>; charged:string; reserved:string;
  error?:string|null; products:{price:string|null;count:number;processed:number}[];
};
const cash=(n:number|string)=>Number(n).toLocaleString('zh-CN',{style:'currency',currency:'CNY'});
const states:Record<string,string>={READY:'待提交',QUEUED:'等待执行',RUNNING:'查询中',TRIAL_DONE:'试查完成',COMPLETED:'已完成',REVIEW:'待核实',STOPPED:'已终止'};

export function BatchConfirmation({job,trial}:{job:ConfirmationJob;trial:boolean}) {
  const trialQuote=trial && job.status==='READY';
  const estimate=job.products.reduce((sum,p)=>sum+Number(p.price)*Math.max(0,(trialQuote?Math.min(5,p.count):p.count)-p.processed),0);
  return <div className="batch-confirm">
    <section><h3>任务信息</h3><div className="batch-confirm-inside">
      <div className="batch-confirm-row"><span>任务名称</span><strong>{job.name}</strong></div>
      <div className="batch-confirm-row"><span>有效数据</span><strong>{job.statistics.valid?.toLocaleString()} 条</strong></div>
      <div className="batch-confirm-row"><span>所选产品</span><strong>{job.products.length} 个</strong></div>
      <div className="batch-confirm-row"><span>执行方式</span><strong>后台分片并行执行</strong></div>
      <div className="batch-confirm-row"><span>任务状态</span><strong>{states[job.status] || job.status}</strong></div>
      {job.error && <p role="alert" className="batch-error">{job.error}</p>}
      <p className="batch-notice">提交后可关闭页面，任务会在后台执行。每个产品单独下载结果文件。</p>
    </div></section>
    <section><h3>费用确认</h3><div className="batch-confirm-inside">
      <p className="batch-muted">{trialQuote?'试查最高费用':'剩余查询预计最高费用'}</p>
      <p className="batch-money">{job.products.some(p => p.price === null) ? '报价待定' : cash(estimate)}</p>
      <div className="batch-confirm-row"><span>已结算</span><strong>{cash(job.charged)}</strong></div>
      <div className="batch-confirm-row"><span>预扣中</span><strong>{cash(job.reserved)}</strong></div>
      <p className="batch-muted">提交时预扣，完成后按产品计费方式据实结算；已查询的数据不重复收费。</p>
    </div></section>
  </div>;
}
